meedy.controller('meedy.officeEditController', ['$scope', '$state', '$stateParams', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceModel', 'meedy.dictionaryModel',
    'meedy.specializationModel', 'meedy.priceListModel', 'meedy.availabilityRuleModel', 'Upload', 'meedy.resourceDetailsModel',
    function ($scope, $state, $stateParams, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel,
              resourceModel, dictionaryModel, specializationModel, priceListModel, availabilityRuleModel, Upload,
              resourceDetailsModel) {

        var listeners = {};

        function setData() {
            $scope.wrapper = new ResourceMeedyVO();
            $scope.wrapper.address = new AddressMeedyVO();

            $scope.forms = {
                editOffice: null
            };

            $scope.phoneRegExp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
            $scope.wwwRegExp = /^[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            $scope.phoneRegExp = '^\\d+$';

            $scope.stateList = [];
            $scope.offices = [];
            $scope.priceListItems = [];
            $scope.priceListItem = new PriceListItemMeedyVO();
            $scope.academicTitleList = [];
            $scope.specializationList = [];
            $scope.resourcePriceList = new ResourcePriceListMeedyVO();
            $scope.croppedPictureData = '';

            $scope.hideAddButton();
            $scope.hideBackButton();
            $scope.resetTitle();

            $scope.vm = {
                selectedSpecializationForOffice: null
            };

            $scope.ageList = [
                {
                    value: 0,
                    label: $scope.T('T.MEEDY.MODULE.MY_DATA.UNDER') + ' 1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR')
                },
                {value: 1, label: '1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR')}
            ];
            for (var i = 2; i < 19; i++) {
                $scope.ageList.push({value: i, label: i + ' ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEARS')});
            }

            $scope.minutes = availabilityRuleModel.generateAppointmentTimeOptions(null, 5, "min");
            $scope.availableLengths = availabilityRuleModel.generateAppointmentTimeOptions(null, 5, "min");

            $scope.officeColorList = [
                //'#ff4f15', '#feae4a', '#9a781d', '#e5bd4c', '#92b70e', '#02f500', '#5d6ffd', '#e5adc8', '#f208ff', '#ffee00', '#d47055', '#9133af', '#d5d30e', '#00d9ff', '#f78888'
                '#ffcdd2', '#CE93D8', '#7986CB', '#90CAF9', '#26C6DA', '#4DB6AC', '#66BB6A', '#C5E1A5', '#CDDC39', '#FFEE58', '#FFD54F', '#FF9800', '#BCAAA4', '#B0BEC5', '#f78888'
            ];

            $scope.doctorCriteria = new ResourceDataGridMeedyCriteria();
            $scope.doctorCriteria.rowsPerSheet = 100000;

            $scope.selectedDoctor = new ResourceDetailsMeedyVO();
            $scope.noDoctorInOffice = false;
            $scope.selectedSpecializationForOffice = null;
            $scope.selectedSpecializationsForOffice = [];
            $scope.specializationFields = ['firstSpecialization', 'secondSpecialization', 'thirdSpecialization', 'fourthSpecialization'];

            $scope.headsUpDayList = [
                { label: '0 dni', value: 0 },
                { label: '1 dzień', value: 1 },
                { label: '2 dni', value: 2 },
                { label: '3 dni', value: 3 },
                { label: '4 dni', value: 4 },
                { label: '5 dni', value: 5 }
            ];
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
                || userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$watch('priceListItem.offer', function (newVal) {
                if (newVal) {
                    $scope.onPriceListChange();
                }
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function (event, dataPage) {
                $scope.stateList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.SUCCESS, function (event, dataPage) {
                for (var i = 0; i < dataPage.data.length; i++) {
                    $scope.academicTitleList.push(dataPage.data[i].name);
                }
            });

            $scope.$on(Event.MEEDY.USER.PWZ_EXISTENCE.SUCCESS, function (event, answer) {
                $scope.duplicatedPwz = answer.exists;
                $scope.forms.editOffice["pwz"].$validate();
            });

            $scope.$on(Event.MEEDY.RESOURCE.SAVE.SUCCESS, function (event, offices) {
                $scope.resourcePriceList.pricelistItems = $scope.priceListItems;
                $scope.resourcePriceList.resource = offices;
                userModel.getLoggedUser();
                priceListModel.savePricelist($scope.resourcePriceList);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.onPriceListChange = function () {
                if ($scope.priceListItem.offer) {
                    var priceList = angular.copy($scope.priceListItem);

                    var alreadyAdded = _.find($scope.priceListItems, function (priceListItem) {
                        return priceListItem.offer.id === $scope.priceListItem.offer.id;
                    });

                    if (!alreadyAdded) {
                        $scope.priceListItems.push(priceList);
                    }
                    $scope.priceListItem = new PriceListItemMeedyVO();
                }
            };

            listeners.onSpecializationsLoad = function (data) {
                $scope.specializationList = data;
            };

            $scope.removePriceList = function (priceList) {
                _.remove($scope.priceListItems, function (priceListItem) {
                    return priceList.offer.id == priceListItem.offer.id;
                });
            };

            $scope.getServicePrice = function (index) {
                return $scope.forms.editOffice['servicePrice' + index].$error;
            };

            $scope.isServicePriceValid = function (index) {
                if (!index) {
                    return;
                }
                return $scope.forms.editOffice['servicePrice' + index].$touched || $scope.forms.editOffice['servicePrice' + index].$dirty || $scope.forms.editOffice.$submitted;
            };

            $scope.$on(Event.MEEDY.RESOURCE.GET_PRICE_LIST.SUCCESS, function (event, resourcePriceList) {
                $scope.resourcePriceList = resourcePriceList;
                $scope.priceListItems = $scope.resourcePriceList.pricelistItems;

                if($scope.wrapper.resourceDetails && !$scope.priceListItems.length) {
                    var ids = $scope.wrapper.resourceDetails.specializationResources.map(function (spec) {
                        return spec.specialization.id;
                    });
                    $scope.getPriceListForSelectedSpecializations(ids);
                }
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_BY_ID.SUCCESS, function (event, office) {
                $scope.wrapper = office;
                $scope.noDoctorInOffice = !$scope.wrapper.resourceDetails;
                $scope.wrapper.resourceDetails = ($scope.wrapper.resourceDetails) ? $scope.wrapper.resourceDetails : null;

                $scope.specializationFields.forEach(function(specField) {
                    if($scope.wrapper[specField]) {
                        $scope.selectedSpecializationsForOffice.push($scope.wrapper[specField]);
                    }
                })
            });

            listeners.onDedicatedSpecializatonLoad = function (data) {
                if (!data.length) {
                    return;
                }

                $scope.priceListItems = data.map(function (offer) {
                    var foundOffer = _.find($scope.priceListItems, function (listOffer) {
                        return listOffer.offer.id === offer.offer.id;
                    });
                    if (!foundOffer) {
                        return {
                            offer: offer.offer,
                            price: (offer.price) ? offer.price : 0,
                            customAppointmentLength: ($scope.wrapper.defaultAppointmentLength) ? $scope.wrapper.defaultAppointmentLength : 0
                        };
                    } else {
                        return foundOffer;
                    }
                });
            };

            listeners.onDataPageLoad = function (dataPage) {
                $scope.doctors = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            };

            $scope.$watch('noDoctorInOffice', function (newValue) {
                if (newValue) {
                    delete $scope.wrapper.resourceDetails;
                }
                if (!newValue && newValue != undefined) {
                    $scope.selectedSpecializationsForOffice = [];
                    $scope.wrapper.resourceDetails = new ResourceDetailsMeedyVO();
                }
            });

            $scope.$watch('vm.selectedSpecializationForOffice', function (newValue) {
                if (newValue) {
                    $scope.selectedSpecializationsForOffice.push(newValue);
                    $scope.vm.selectedSpecializationForOffice = null;
                }
            })
        }

        function setActions() {
            $scope.uploadPicture = function (pictureData, pictureName) {
                var croppedFile = Upload.dataUrltoBlob(pictureData, pictureName);
                userModel.uploadOfficePicture(croppedFile, null, $scope.wrapper.id);

                var successWatcherDisabler = $scope.$on(Event.MEEDY.USER.UPLOAD_MY_PICTURE.SUCCESS, function (event, result) {
                    successWatcherDisabler();
                    errorWatcherDisabler();

                    $scope.refreshingDataAfterPictureUpload = true;
                    $scope.pictureFile = null;
                    $scope.croppedPictureData = '';
                    resourceModel.getById($stateParams.id);
                });

                var errorWatcherDisabler = $scope.$on(Event.MEEDY.USER.UPLOAD_MY_PICTURE.ERROR, function (event, error) {
                    successWatcherDisabler();
                    errorWatcherDisabler();
                });
            };

            $scope.deletePicture = function () {
                userModel.deleteOfficePicture($scope.wrapper.id);

                var successWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.SUCCESS, function (event, result) {
                    successWatcherDisabler();
                    errorWatcherDisabler();

                    $scope.refreshingDataAfterPictureUpload = true;
                    resourceModel.getById($stateParams.id);
                });

                var errorWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.ERROR, function (event, error) {
                    successWatcherDisabler();
                    errorWatcherDisabler();
                });
            };

            $scope.validatePwz = function () {
                if ($scope.wrapper.pwz) {
                    userModel.pwzExistence($scope.wrapper.pwz);
                }
            };

            $scope.evaluatePwzRequirement = function () {
                var wrapper = $scope.wrapper;
                if (wrapper) {
                    var firstSpecialization = firstSpecialization;
                    var secondSpecialization = secondSpecialization;
                    $scope.pwzRequired = (firstSpecialization && firstSpecialization.pwzRequired)
                        || (secondSpecialization && secondSpecialization.pwzRequired);
                }
            };

            $scope.save = function () {
                $scope.forms.editOffice.$setSubmitted();
                if ($scope.forms.editOffice.$valid) {

                    if ($scope.noDoctorInOffice) {
                        delete $scope.wrapper.resourceDetails;
                        $scope.selectedSpecializationsForOffice.forEach(function (spec, idx) {
                            $scope.wrapper[$scope.specializationFields[idx]] = spec;
                        });
                    }

                    if($scope.wrapper.useMedicalPostAddressData) {
                        delete $scope.wrapper.address;
                    }

                    resourceModel.saveOrUpdate($scope.wrapper).then(function (data) {
                        $scope.resourcePriceList.pricelistItems = $scope.priceListItems;
                        $scope.resourcePriceList.resource = data;
                        priceListModel.savePricelistForAbc($scope.resourcePriceList);
                    }, function () {

                    })
                }
            };

            $scope.getPriceListForSelectedSpecializations = function (physicianSpecIdList) {
                var ids = (physicianSpecIdList) ? physicianSpecIdList : [];
                if(!physicianSpecIdList) {
                    ids.push($scope.wrapper.firstSpecialization.id);
                    if ($scope.wrapper.secondSpecialization) {
                        ids.push($scope.wrapper.secondSpecialization.id);
                    }
                    if ($scope.wrapper.thirdSpecialization) {
                        ids.push($scope.wrapper.thirdSpecialization.id);
                    }
                    if ($scope.wrapper.fourthSpecialization) {
                        ids.push($scope.wrapper.fourthSpecialization.id);
                    }
                }

                priceListModel.getPriceListBasedOnSpecializations(ids.join(",")).then(listeners.onDedicatedSpecializatonLoad)
            };

            $scope.getMatches = function (query) {
                var results = [];

                _.forEach($scope.specializationList, function (specialization) {
                    if (specialization.name.indexOf(query) > -1) {
                        results.push(specialization);
                    }
                });

                return results;
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.EDIT_OFFICE');
        }

        function initialize() {
            resourceModel.getById($stateParams.id);
            resourceModel.getPricelist($stateParams.id);
            resourceDetailsModel.getDataPage($scope.doctorCriteria).then(listeners.onDataPageLoad);
            specializationModel.getSpecializations().then(listeners.onSpecializationsLoad);
            dictionaryModel.getStates();
            dictionaryModel.getAcademicTitles();
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
